import api from '@/api/api';

export default {
    obterDocumentoRecenteBase64(storageId, params = {}) {
        return api.get(route('documento.recente-base64', { storage_id: storageId }), { params });
    }
};
